import type { StoreFeatures } from './type';

export const store: StoreFeatures = {
    enabled: false,
    _description: 'Enables Store for buying new products',
    disableAnalyticsPackage: {
        enabled: false,
        _description: 'Removes the analytics URL param from store handover',
    },
    oidc: {
        enabled: false,
        _description:
            'Does the Store in the local bank support Open ID Connect? If yes, token exchange should not happen.',
    },
    passCurrentAccessToken: {
        enabled: true,
        _description: 'Send an access token to the local store',
    },
    search: {
        enabled: false,
        _description: 'Search input for offers in the store',
    },
};
